import erc20Abi from "./abi/erc20.json";
import coin from "./abi/coin.json";
import { SGBToken } from "../icons/tokens/SGBToken";
import { CAND } from "../icons/tokens/CAND";
var tokens = [
    {
        name: "SGB",
        address: "0x02f0826ef6aD107Cfc861152B32B52fD11BaB9ED",
        abi: coin,
        erc: false,
        decimals: 18,
        balance: "0",
        icon: SGBToken,
    },
    {
        name: "CAND",
        address: "0x70Ad7172EF0b131A1428D0c1F66457EB041f2176",
        abi: erc20Abi,
        erc: true,
        decimals: 18,
        balance: "0",
        icon: CAND,
    },
];
export default tokens;
